


























































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  Badge,
  Button,
  Card,
  Tag,
  Tooltip,
  Dropdown,
  DropdownMenu,
  DropdownItem
} from 'element-ui';
import AssignedOperator from '@/components/shipment/AssignOperator.vue';
import Milestones from '@/components/shipment/list/Milestones.vue';
import { shipmentService } from '@/services/ShipmentService';

import {
  ShipmentFields,
  TransportationTypeEnum,
  CargoTypeEnum,
  ShipmentStatusEnum
} from '@/types/graphql/schemaTypes';

import get from 'lodash/get';
import { statusColor } from '@/utilities/textUtils';

// gql
import updateShipment from '@/graphql/mutations/ShipmentUpdate.gql';

@Component({
  components: {
    AssignedOperator,
    Milestones,
    'el-badge': Badge,
    'el-button': Button,
    'el-card': Card,
    'el-tag': Tag,
    'el-tooltip': Tooltip,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem
  }
})
export default class ShipmentListItem extends Vue {
  @Prop() private shipment!: ShipmentFields;

  private isLoading = false;

  private statusColor(): string {
    return statusColor(this.shipment);
  }

  private cargo() {
    if (this.shipment.transportationType === TransportationTypeEnum.air) {
      return TransportationTypeEnum.air.toUpperCase();
    }
    return this.shipment.cargoType || '-';
  }

  private cargoDetails() {
    if (!this.shipment.cargoDescription) {
      return;
    }

    const description = [];

    if (
      this.shipment.cargoType === CargoTypeEnum.FCL &&
      this.shipment.cargoDescription.containers
    ) {
      this.shipment.cargoDescription.containers.forEach((container, index) => {
        if (index > 1) {
          // more than 2 ? => elippsis
          description.push('...');
          return;
        }
        description.push(
          `${this.$t(`container.sizes.${container.requestedContainerType}`)} ✕
          ${container.requestedContainerCount}`
        );
      });
    } else if (this.shipment.cargoDescription.parcels) {
      this.shipment.cargoDescription.parcels.forEach((parcel, index) => {
        if (index > 1) {
          // more than 2 ? => elippsis
          description.push('...');
          return;
        }
        description.push(
          `${this.$t(`parcel.packaging-types.${parcel.packagingType}`)} ✕ ${
            parcel.quantity
          }`
        );
      });
    }
    return description.join(', ');
  }

  private latestIsCustomer() {
    return (
      get(this.shipment, 'lastPublicChannelMessage.sender.senderType') ===
      'shipper'
    );
  }

  // @param command: billId or 'changeStatus'
  private handleCommand(command) {
    if (command === 'changeStatus') {
      this.toggleBillingComplete();
    } else {
      this.redirectToBill(command);
    }
  }

  private redirectToBill(id: string): void {
    this.$router.push({
      name: 'billDetails',
      params: { id }
    });
  }

  private async toggleBillingComplete() {
    this.isLoading = true;

    try {
      const response = await this.$apollo.mutate({
        mutation: updateShipment,
        variables: {
          shipmentUpdateArgs: {
            billingComplete: !this.shipment.billingComplete,
            id: this.shipment.id
          }
        }
      });

      if (response) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });

        this.$emit('refresh');
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.isLoading = false;
    }
  }
}
